export class PwaLabelWithTooltip extends HTMLElement {
  static tagName = "pwa-label-with-tooltip"

  #handleDocumentClick = (event) => {
    if (!this.contains(event.target)) {
      this.#close()
    }
  }

  #handleClick = () => {
    if (this.hasAttribute("open")) {
      this.#close()
    } else {
      this.setAttribute("open", "")
      document.addEventListener("click", this.#handleDocumentClick)
    }
  }

  connectedCallback() {
    this.addEventListener("click", this.#handleClick)
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.#handleDocumentClick)
  }

  #close() {
    this.removeAttribute("open")
    document.removeEventListener("click", this.#handleDocumentClick)
  }
}
